import EditorSection from "../../components/EditorSection";
import { Button, ColorPicker, FileUpload, Input, Label, PasswordInput, } from "@akin2unde/flowui-react";
import PantryStackLogo from "../../components/PantryStackLogo/PantryStackLogo";
import { TenantSetup } from "./TenantSetup";
import "./TenantSetupCss.css";
export default function TenantSetupHTML() {
    const { state, TenantUrl, SetProperty, SetThemeProperty, SetAddress, AddAddress, RemoveAddress, SetLogo, Submit, } = TenantSetup();
    return (<main className="tenant-setup-page">
      <section className="tenant-setup-panel">
        <header className="tenant-setup-header">
          <div>
            <span>Initial setup</span>
            <h1>Set up your tenant</h1>
            <p>The branding selected here applies to every tenant user.</p>
          </div>
        </header>

        <form className="tenant-setup-form" onSubmit={Submit}>
          <EditorSection className="tenant-setup-section" title={<>Business details</>}>
            
            <div className="tenant-setup-grid">
              <div className="tenant-setup-field">
                <Label htmlFor="business-name" required>
                  Business name
                </Label>
                <Input id="business-name" required value={state.BusinessName} onChange={(event) => SetProperty("BusinessName", event.target.value)}/>
              </div>

              <div className="tenant-setup-field">
                <Label htmlFor="tenant-url">Tenant URL</Label>
                <Input id="tenant-url" value={TenantUrl} readOnly/>
                <small>This is detected from the current browser URL.</small>
              </div>
              <div className="tenant-setup-field">
                <Label htmlFor="default-warehouse-name">
                  Default warehouse name (optional)
                </Label>
                <Input id="default-warehouse-name" value={state.DefaultWareHouseName ?? ""} onChange={(event) => SetProperty("DefaultWareHouseName", event.target.value)}/>
                <small>
                  Create the first warehouse and assign it to the administrator.
                </small>
              </div>
              <div className="tenant-setup-field tenant-setup-field-full">
                <div className="tenant-setup-label-row">
                  <Label htmlFor="address-0" required>
                    Phone Numbers
                  </Label>
                </div>
                <div className="tenant-address-list">
                  <div className="tenant-address-row">
                    <Input id={`phoneNumber`} required value={state.BusinessPhones} placeholder={`Business phone number(s) comma separated`} onChange={(event) => SetProperty("BusinessPhones", event.target.value)}/>
                  </div>
                </div>
              </div>
              <div className="tenant-setup-field tenant-setup-field-full">
                <div className="tenant-setup-label-row">
                  <Label htmlFor="address-0" required>
                    Addresses
                  </Label>
                  <Button type="button" variant="ghost" onClick={AddAddress}>
                    Add address
                  </Button>
                </div>
                <div className="tenant-address-list">
                  {state.Addresses.map((address, index) => (<div className="tenant-address-row" key={index}>
                      <Input id={`address-${index}`} required value={address} placeholder={`Business address ${index + 1}`} onChange={(event) => SetAddress(index, event.target.value)}/>
                      {state.Addresses.length > 1 && (<Button type="button" variant="ghost" color="danger" ariaLabel={`Remove address ${index + 1}`} onClick={() => RemoveAddress(index)}>
                          <i className="fa-solid fa-trash"/>
                        </Button>)}
                    </div>))}
                </div>
              </div>

              <div className="tenant-setup-field tenant-setup-field-full">
                <Label required>Business logo</Label>
                <FileUpload accept="image/png,image/jpeg,image/webp,image/svg+xml" preview maxSize={2 * 1024 * 1024} onChange={SetLogo}/>
              </div>
            </div>
          </EditorSection>

          <EditorSection className="tenant-setup-section" title={<>First tenant administrator</>}>
            
            <div className="tenant-setup-grid">
              <div className="tenant-setup-field">
                <Label htmlFor="first-name" required>
                  First name
                </Label>
                <Input id="first-name" required value={state.FirstName} onChange={(event) => SetProperty("FirstName", event.target.value)}/>
              </div>
              <div className="tenant-setup-field">
                <Label htmlFor="last-name" required>
                  Last name
                </Label>
                <Input id="last-name" required value={state.LastName} onChange={(event) => SetProperty("LastName", event.target.value)}/>
              </div>
              <div className="tenant-setup-field">
                <Label htmlFor="admin-email" required>
                  Email address
                </Label>
                <Input id="admin-email" type="email" required value={state.Email} onChange={(event) => SetProperty("Email", event.target.value)}/>
              </div>
              <div className="tenant-setup-field">
                <Label htmlFor="admin-password" required>
                  Password
                </Label>
                <PasswordInput id="admin-password" required showToggle value={state.Password} onChange={(event) => SetProperty("Password", event.target.value)}/>
              </div>
            </div>
          </EditorSection>

          <EditorSection className="tenant-setup-section" title={<>Tenant theme</>}>
            
            <p className="tenant-theme-help">
              These values generate the FlowUI theme used on login and across
              the whole application.
            </p>
            <div className="tenant-theme-grid">
              {([
            ["PrimaryColor", "Primary color"],
            ["SecondaryColor", "Secondary color"],
            ["CanvasColor", "Page background"],
            ["SurfaceColor", "Card and dialog surface"],
            ["TextColor", "Main text"],
            ["BorderColor", "Borders"],
        ] as const).map(([property, label]) => (<div className="tenant-color-field" key={property}>
                  <Label>{label}</Label>
                  <div>
                    <ColorPicker value={state.Theme[property]} onChange={(event) => SetThemeProperty(property, event.target.value)}/>
                    <Input value={state.Theme[property]} onChange={(event) => SetThemeProperty(property, event.target.value)}/>
                  </div>
                </div>))}
              <div className="tenant-setup-field">
                <Label htmlFor="corner-radius">Corner radius</Label>
                <Input id="corner-radius" type="number" min={0} max={24} value={state.Theme.CornerRadius} onChange={(event) => SetThemeProperty("CornerRadius", Number(event.target.value))}/>
              </div>
            </div>
          </EditorSection>

          <footer className="tenant-setup-actions">
            <Button type="submit" size="lg">
              Create tenant and administrator
            </Button>
          </footer>
        </form>
      </section>
    </main>);
}
